import ThemeOptions from './ThemeOptions';
import { culturesRender } from './cultures';
import currencies from './currencies';
import regions from './regions';
import truckList from './truckList';
import pbiMng from './powerbi-mng';
import releaseNote from './releaseNote';
import boxes from './boxes';
import { programRender } from './programReducer'
import clients from './clients'
import countries from './countries';
import companies from './companies';
import requestTypes from './requestTypes'
import requestStages from './requestStages'
import requestStageInputFields from './requestStageInputFields'
import requestStageStatuses from './requestStageStatuses'
import packaging from './packaging'
import auth from './auth'
import user from './user'
import processList from './processList'
import programs from './programs'
//import {carriersRender} from './Carriers'
import TakeBackOptions from './TakeBackOptions'
import processingpartner from './processingpartner'
import carriers from './carriers'
import assetsStatus from './assetsStatus';
import assets from './assets';
import additionalInfo from './additionalInfo'
import programProcess from './programProcess'
import roles from './roles';
import rightObjects from './rightObjects';
import statuses from './statuses';
import servicetype from './servicetype'
import services from './services'
import documentTypes from './documentTypes'
import labels from './labels'
import manufacturers from './manufacturers'
import podetails from './podetails';
import syncing from './syncing';
import dateFormat from './dateFormat';
import powerbi from './powerbi';
import storyboard from './storyboard';
import brands from './brand';
import eventKeys from './eventKeys';
import entities from './entities';
import emailNotification from './emailNotification';
import b2cCustomer from './b2cCustomer';
import recursive from './recursive';
import models from './models';
import holidays from './holidays';
import standardprofiles from "./standardprofiles";
import portalCategories from './portalcategories';
export default {
    auth,
    user,
    processList,
    ThemeOptions,
    culturesRender,
    currencies,
    regions,
    programRender,
    clients,
    countries,
    companies,
    requestTypes,
    requestStages,
    requestStageInputFields,
    requestStageStatuses,
    packaging,
    boxes,
    truckList,
    pbiMng,
    releaseNote,
    programs,
    //carriersRender,
    TakeBackOptions,
    processingpartner,
    assetsStatus,
    assets,
    programProcess,
    carriers,
    roles,
    rightObjects,
    statuses,
    servicetype,
    services,
    documentTypes,
    labels,
    manufacturers,
    podetails,
    additionalInfo,
    syncing,
    dateFormat,
    powerbi,
    storyboard,
    brands,
    eventKeys,
    entities,
    b2cCustomer,
    recursive,
    models,
    emailNotification,
    holidays,
    standardprofiles,
    portalCategories
};
